import { render, staticRenderFns } from "./Muestreo.vue?vue&type=template&id=d2f54292"
import script from "./Muestreo.vue?vue&type=script&lang=js"
export * from "./Muestreo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports